import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../lib/api';
import { ArrowLeft } from 'lucide-react';
import useSEO from '../hooks/useSEO';

const NewsDetail = () => {
    const { key } = useParams();
    const [post, setPost] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        api.get(`/news/${key}`)
            .then((r) => setPost(r.data))
            .catch(() => setNotFound(true));
    }, [key]);

    useSEO(post ? {
        title: post.title,
        description: (post.excerpt || post.content || '').slice(0, 160),
        image: post.cover_image || '',
        type: 'article',
    } : {});

    if (notFound) {
        return (
            <div className="container-page pt-32 pb-24" data-testid="news-not-found">
                <h1 className="font-display font-black uppercase text-4xl">Article not found</h1>
                <Link to="/news" className="mt-6 inline-flex items-center gap-2 text-brand-primary label-caps">
                    <ArrowLeft className="h-4 w-4" /> Back to news
                </Link>
            </div>
        );
    }

    if (!post) return <div className="container-page pt-32 pb-24 text-white/50">Loading…</div>;

    return (
        <div data-testid="news-detail-page">
            <div className="container-page pt-28 pb-24 max-w-4xl">
                <Link to="/news" className="inline-flex items-center gap-2 label-caps text-white/60 hover:text-white transition-colors" data-testid="news-back-link">
                    <ArrowLeft className="h-4 w-4" /> Back to news
                </Link>

                <div className="mt-8">
                    <div className="label-caps text-white/40 mb-4">
                        {new Date(post.created_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                        {' • '}{post.author}
                    </div>
                    <h1 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl text-white">
                        {post.title}
                    </h1>
                </div>

                {post.cover_image && (
                    <div className="mt-10 aspect-video border border-white/10 overflow-hidden bg-brand-surface">
                        <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
                    </div>
                )}

                <div className="mt-10 text-lg text-white/80 leading-relaxed whitespace-pre-line" data-testid="news-content">
                    {post.content}
                </div>

                {post.tags && post.tags.length > 0 && (
                    <div className="mt-12 flex flex-wrap gap-2">
                        {post.tags.map((t) => (
                            <span key={t} className="label-caps border border-white/20 text-white/60 px-3 py-1">
                                #{t}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default NewsDetail;
